
export class PageLoaderNames {
  static readonly SYMYTAR_DA_QUEST =
    "/po2RT/htmlForm/SYMITAR/APPS/DigitalApps/Quest/index.html";
}
